import { render } from "./Home.vue?vue&type=template&id=3daf058b&scoped=true"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"

import "./Home.vue?vue&type=style&index=0&id=3daf058b&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-3daf058b"

export default script